import './login-input.scss';
import LoginComponent from '../login-component';

export default class LoginInput extends LoginComponent {

    constructor(props) {
        super(props);
    }

    render() {
        const placeholderClass = `input-placeholder ${this.props.error ? 'error' : ''} `
            + `${this.props.value || /^\s+$/.test(this.props.value) ? 'filled' : ''}`;

        let inputId = this.props.id;

        // noinspection CheckTagEmptyBody
        return (
            <div className={placeholderClass}>
                {this.props.error
                    ? <label
                        className="input-error"
                        htmlFor={inputId}
                        dangerouslySetInnerHTML={{__html: this.props.error}}>

                      </label>
                    : null
                }
                <input id={inputId}
                       name={inputId}
                       className="login-input"
                       type={this.props.type}
                       value={this.props.value}
                       maxLength={this.props.maxLength}
                       onChange={this.props.onChange}
                       onFocus={this.props.onFocus}
                       onBlur={this.props.onBlur} />
                <label className="placeholder"
                       htmlFor={inputId}>
                    {this.props.label}
                </label>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/ui-elements/login-input.jsx
 **/